import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import UserDataTable from "./UserDataTable";
import { closeModal, fetchUsers, openModal } from "./store/userDataSlice";
import AddUserDataModal from "./AddUserDataModal";

const Users = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.userData || {});

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="User"
            title="Dashboard"
            subtitle="User"
            name="Add User"
            onAddClick={() => dispatch(openModal())} 
          />
          <UserDataTable data={data} loading={loading} />

          <AddUserDataModal
            show={isModalOpen}
            onClose={() => dispatch(closeModal())}
          />
        </div>
      </div>
    </div>
  );
};

export default Users;
